// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:04:01

export default {
  "id": "mega-lamba-ramp",
  "slug": "mega-lamba-ramp",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/08f7196aa8c241dc81f27f118fa1f61e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/08f7196aa8c241dc81f27f118fa1f61e/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mega Lamba Ramp",
      "description": "Crazy car stunts and stunt car racing games that will give you the most thrilling experience. Perform dangerous stunts on impossible tracks in our racing and stunt simulator. Perform stunts on all the cars for your favorite characters to move to the next level!",
      "instructions": "To complete the level, you need to get into the car with your character and do tricks on all the cars. \n\nControls: WASD and arrows - move the car and the character, R - flip the car, Shift - accelerate the character and nitro when driving a car Space - handbrake \n\nPhone controls: move the steering wheel with your finger left and right to turn. Press the forward and backward buttons to accelerate and brake.",
      "genres": [
        "Racing & Driving"
      ],
      "tags": [
        "3d",
        "car",
        "road",
        "transport",
        "truck"
      ]
    },
    "zh-CN": {
      "title": "巨浪斜坡",
      "description": "疯狂汽车特技和特技赛车游戏，将带给您最刺激的体验。在我们的赛车和特技模拟器中，在不可能的赛道上执行危险特技。为您的最爱角色执行特技，使其升到下一级！",
      "instructions": "要完成关卡，你需要驾驶你的角色进入车辆并在所有车辆上表演特技。\n\n控制方式：WASD和箭头键 - 控制车辆和角色的移动，R - 翻转车辆，Shift - 加速角色和在驾驶车辆时使用氮气，空格键 - 刹车\n\n手机控制：用手指左右移动方向盘以转向。按下前进和后退按钮以加速和刹车。",
      "genres": [
        "赛车与驾驶"
      ],
      "tags": [
        "三维",
        "汽车",
        "道路",
        "交通",
        "卡车"
      ]
    },
    "zh-TW": {
      "title": "巨羊拉坡",
      "description": "瘋狂車技和車技賽車遊戲，將帶給您最刺激的體驗。在賽車和車技模擬器中，在不可能的賽道上演習危險的車技。為了您最喜愛的角色升級，在所有車輛上展現車技！",
      "instructions": "為了完成關卡，你需要讓你的角色進入車內，並在所有車輛上進行特技表演。\n\n控制方式：WASD 和方向鍵 - 移動車輛和角色，R - 翻轉車輛，Shift - 加速角色和在駕駛車輛時使用氮氣，空格鍵 - 手煞車\n\n手機控制：用手指左右滑動來轉動方向盤。按住前進和後退按鈕來加速和煞車。",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "3D",
        "汽車",
        "道路",
        "交通",
        "卡車"
      ]
    },
    "zh-HK": {
      "title": "超級羊角斜坡",
      "description": "瘋狂車技及車技賽車遊戲，帶你體驗最刺激的感覺。在我們的賽車及車技模擬器中，在不可能的軌道上進行危險的車技表演。為了你最喜愛的角色，在所有車輛上表演車技，進入下一個等級！",
      "instructions": "為了完成關卡，你需要讓角色進入車內，並在所有車輛上施展技巧。\n\n操控方式：WASD 和箭頭鍵 - 運動車輛和角色，R - 翻轉車輛，Shift - 加速角色和車輛時的氮氣，Space - 手刹\n\n手機操控：用手指左右移動方向盤來轉向。按鈕向前和向後來加速和煞車。",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "3D",
        "車輛",
        "道路",
        "運輸",
        "卡車"
      ]
    },
    "ja": {
      "title": "メガランバランプ",
      "description": "クレイジーカーストントラックとスタントカーレースゲームで最もスリル満点の体験を提供します。レースとスタントシミュレータ内で不可能なトラックで危険なスタントを披露しましょう！お気に入りのキャラクターの次のレベルに進むために、全ての車でスタントを披露してください！",
      "instructions": "レベルをクリアするには、キャラクターで車に乗り込み、すべての車にトラックを当てる必要があります。\n\nコントロール：WASDと矢印 - 車とキャラクターを動かす、R - 車を転がす、Shift - キャラクターと車の氮化ガスを加速、Space - ハンドブレーキ\n\nスマートフォンコントロール：指でステアリングを左と右に動かしてターン、進行と後退ボタンを押して加速とブレーキを行います。",
      "genres": [
        "レーシングとドライビング"
      ],
      "tags": [
        "3D",
        "車",
        "道路",
        "交通",
        "トラック"
      ]
    },
    "ko": {
      "title": "메가 램바 램프",
      "description": "추격적인 카트 스탠트와 스탠트 카 레이싱 게임으로 가장 흥미진진한 경험을 제공합니다. 레이싱과 스탠트 시뮬레이터에서 불가능한 트랙에서 위험한 스탠트를 수행하세요! 귀하의 취향에 맞는 캐릭터의 차량에서 스탠트를 수행하여 다음 단계로 진행하세요!",
      "instructions": "레벨을 완료하려면 캐릭터와 차에 올라가 모든 차에 트릭을 해야 합니다.\n\n제어 방법: WASD와 방향키 - 차와 캐릭터 이동, R - 차를 뒤집기, Shift - 캐릭터와 차를 달리는 동안 가속과 니트로, 공간바 - 핸들브레이크\n\n폰 제어 방법: 손가락으로 스티어링을 왼쪽과 오른쪽으로 돌리기. 앞쪽과 뒤쪽 버튼을 눌러 가속과 제동하기.",
      "genres": [
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "3D",
        "자동차",
        "도로",
        "교통",
        "트럭"
      ]
    },
    "fr": {
      "title": "Mégaslope Lamba",
      "description": "Courses de stunts de voitures folles et jeux de courses de voitures avec des stunts qui vous offriront l'expérience la plus palpitante. Réalisez des stunts dangereux sur des circuits impossibles dans notre simulateur de course et de stunts. Réalisez des stunts sur toutes les voitures pour les personnages de votre choix afin de passer au niveau suivant !",
      "instructions": "Pour terminer le niveau, vous devez monter dans la voiture avec votre personnage et faire des figures sur toutes les voitures.\n\nContrôles : WASD et flèches - déplacer la voiture et le personnage, R - renverser la voiture, Maj - accélérer le personnage et le nitro en conduisant une voiture Espace - frein à main\n\nContrôles téléphone : déplacez le volant avec votre doigt de gauche à droite pour tourner. Appuyez sur les boutons avant et arrière pour accélérer et freiner.",
      "genres": [
        "Course et conduite"
      ],
      "tags": [
        "3D",
        "voiture",
        "route",
        "transport",
        "camion"
      ]
    }
  }
};
